/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description':
    'Обратитесь за помощью к участникам команды или администратору.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title':
    'Не удалось получить результаты поиска',
};
